"use client";

import dynamic from "next/dynamic";

import type { ToastProps } from "./toast.component";

export const Toast = dynamic<ToastProps>(() => import("./toast.component"), {
  ssr: false,
});

export type { ToastProps } from "./toast.component";
